angular.module('dnecom')
    .controller('ProductsController', ["$scope", "wizardModal", "$http", "$timeout", "notifications", "$location", "$window", "DTOptionsBuilder", "DTColumnDefBuilder", "$sce", "$filter", "StorageBag", "$uibModal", "$confirm", "ProductUtils", function ProductsController($scope, wizardModal, $http, $timeout, notifications, $location, $window, DTOptionsBuilder, DTColumnDefBuilder, $sce, $filter, StorageBag, $uibModal, $confirm, ProductUtils) {
        let vm = this;
        $scope.currentStore = TemplateData.value('store');
        $scope.productUrlTemplate = TemplateData.value('productUrl');
        $scope.freshProductsCountPerStatus = TemplateData.value('freshProductsCountPerStatus');
        $scope.sources = TemplateData.value('productSources');

        $scope.loading = false;
        $scope.sorting = {id: 'priority', direction: 'asc'};
        $scope.detailsLoading = false;
        $scope.data = {};
        $scope.data.displayLength = 15;
        $scope.data.page = 1;
        $scope.count = 0;
        $scope.activeView = _.isNull(StorageBag.get('es-ui-product-view')) ? 'table' : StorageBag.get('es-ui-product-view');
        $scope.tooltips = {
            quantity: $sce.trustAsHtml('<span>Remaining / <b>Total</b></span>'),
            price: $sce.trustAsHtml('<span>Current Price / <span class="line-through">Regular Price</span></span>')
        };

        $scope.tableColumns = {1: true, 2: true, 3: true, 4: true, 5: true};

        $scope.changeableStatus = ['private', 'public', 'draft'];
        vm.statusToChange = ''

        $scope.showWaitingReports = false;
        $scope.showFinishedReports = false;
        $scope.finishedReportData = {};

        vm.allChecked = false;

        $scope.data.availableLength = [
            {id: 15, value: 15},
            {id: 30, value: 30},
            {id: 50, value: 50},
            {id: 100, value: 100},
            {id: 150, value: 150},
            {id: 200, value: 200},
            {id: -1, value: 'all'}
        ];

        $scope.tileViewInstance = {
            search: '',
            displayLength: $scope.data.displayLength,
            pages: {}
        };

        $scope.tableInstance = {};
        $scope.dtInstanceCallback = function(dtInstance)
        {
            $scope.tableInstance = dtInstance;
        };

        var sortingOrder = [
            [14, 'asc'],  // priority
            [7, 'desc'], // status (public before private)
            [1, 'asc']   // name
        ];

        $scope.dtProductsTableOptions =  DTOptionsBuilder.newOptions().withOption('aaSorting', sortingOrder).withDisplayLength($scope.data.displayLength);

        $scope.dtProductsColumnDefs = [
            {
                targets: 'col-hidden',
                visible: false
            },
            {
                targets: 'col-sales-terms',
                orderData: [11, 12],
                width: '112px'
            },
            {
                targets: 'col-actions',
                orderable: false,
                width: '202px'
            },
            {
                targets: 'col-order',
                orderable: false,
            },
            {
                targets: 'col-price',
                iDataSort: 8
            },
            {
                targets: 'col-quantity',
                iDataSort: 9
            },
            {
                targets: 'col-modified',
                iDataSort: 10
            }
        ];

        $scope.selectedStatus = 'public';
        $scope.searchText = '';

        $scope.reorderingEnabled = false;
        $scope.productsOrder = [];

        $scope.sortableOptions = {
            handle: '.sort-handle',

            update: function(e, ui) {
                var productId = parseInt(ui.item.attr('product-id'));

                var prevPosition = $scope.productsOrder.indexOf(productId);
                var currentPosition = getRowNumber(productId);

                refreshProductsOrder();
            }
        };

        var updateTileViewPagesFromTo = function () {
            $scope.tileViewInstance.pages.from =  ($scope.tileViewInstance.pages.current - 1) * $scope.tileViewInstance.displayLength + 1;
            $scope.tileViewInstance.pages.to =  $scope.tileViewInstance.pages.from + $scope.tileViewInstance.displayLength - 1;

            if ($scope.tileViewInstance.pages.to > $scope.tileViewInstance.pages.size) {
                $scope.tileViewInstance.pages.to = $scope.tileViewInstance.pages.size;
            }
        };

        var calcTileViewPages = function (count) {
            $scope.tileViewInstance.pages.size = parseInt(count);

            if ($scope.tileViewInstance.displayLength === -1) {
                $scope.tileViewInstance.displayLength = $scope.tileViewInstance.pages.size;
            }

            $scope.tileViewInstance.pages.max = Math.max(1, Math.ceil($scope.tileViewInstance.pages.size / $scope.tileViewInstance.displayLength));

            if (typeof $scope.tileViewInstance.pages.current === 'undefined') {
                $scope.tileViewInstance.pages.current = 1;
            }

            if ($scope.tileViewInstance.pages.current > $scope.tileViewInstance.pages.max) {
                $scope.tileViewInstance.pages.current = $scope.tileViewInstance.pages.max;
            }

            updateTileViewPagesFromTo();
        };

        $scope.changeLength = function() {
            $scope.tileViewInstance.displayLength = $scope.data.displayLength;
            $scope.getProducts();
        };

        $scope.someChecked = function () {
            var checked = false;
            for (var i in $scope.products) {
                if ($scope.products[i].checked) {
                    checked = true;
                }
            }

            return checked;
        };

        $scope.allCheck = function () {
            if (vm.allChecked) {
                for (var i in $scope.products) {
                    $scope.products[i].checked = true;
                }
            } else {
                for (var i in $scope.products) {
                    $scope.products[i].checked = false;
                }
            }
        }

        $scope.removeSelectedProducts = function () {
            let productsToDelete = [];
            for (var i in $scope.products) {
                if ($scope.products[i].checked) {
                    productsToDelete.push($scope.products[i].id);
                }
            }
            var modal = wizardModal.open({
                'templateUrl': 'deleteButchModal.html',
                'size': 'md',
                'windowClass': 'modal-danger-light-header',
                'controller': function ($scope, $uibModalInstance, productsToDelete) {
                    $scope.productsToDelete = productsToDelete;
                    $scope.$uibModalInstance = $uibModalInstance;
                },
                'resolve': {
                    'productsToDelete': function() {
                        return productsToDelete;
                    }
                }
            });

            modal.result.then(function (productsToDelete) {
                $scope.deleteBatch(productsToDelete);
            }, function () {
                for (var i in $scope.products) {
                    $scope.products[i].checked = false;
                }
                vm.allChecked = false;
            });
        };

        $scope.changeStatus = function () {
            if (!vm.statusToChange) {
                return;
            }
            let productsToChange = [];
            for (var i in $scope.products) {
                if ($scope.products[i].checked) {
                    productsToChange.push($scope.products[i].id);
                }
            }
            var modal = wizardModal.open({
                'templateUrl': 'statusButchModal.html',
                'size': 'md',
                'controller': function ($scope, $uibModalInstance, productsToChange, status) {
                    $scope.productsToChange = productsToChange;
                    $scope.$uibModalInstance = $uibModalInstance;
                    $scope.status = status;
                },
                'resolve': {
                    'productsToChange': function() {
                        return productsToChange;
                    },
                    'status': function() {
                        return vm.statusToChange;
                    },

                }
            });

            modal.result.then(function (productsToChange) {
                $http
                    .post(
                        Routing.generate('products_change_status_batch', {
                            id: $scope.currentStore.id
                        }),
                        {
                            products: productsToChange,
                            status: vm.statusToChange,
                        }
                    )
                    .success(function(response) {
                        if (!response.success) {
                            notifications.danger(response.message || 'Unknown error.');
                            for (var i in $scope.products) {
                                $scope.products[i].checked = false;
                            }
                            vm.allChecked = false;
                            return;
                        }

                        notifications.success('Status changed successfully.');
                        var currentView = $scope.activeView;
                        $scope.activeView = '';

                        $scope.getProducts();

                        $timeout(function() {
                            $scope.activeView = currentView;
                        });
                    })
                    .error(function() {
                        notifications.danger('Invalid server response.');
                    })
            }, function () {
                for (var i in $scope.products) {
                    $scope.products[i].checked = false;
                }
                vm.allChecked = false;
            });
        };

        $scope.deleteBatch = function(items) {
            $http
                .post(
                    Routing.generate('products_delete_batch', {
                        id: $scope.currentStore.id
                    }),
                    {
                        products: items
                    }
                )
                .success(function(response) {
                    if (!response.success) {
                        for (var i in $scope.products) {
                            if ($scope.products[i].checked) {
                                $scope.products[i].checked = false;
                            }
                        }
                        vm.allChecked = false;
                        notifications.danger(response.message || 'Unknown error.');
                        return;
                    }

                    notifications.success('Products deleted successfully.');
                    var currentView = $scope.activeView;
                    $scope.activeView = '';

                    $scope.getProducts();

                    $timeout(function() {
                        $scope.activeView = currentView;
                    });
                })
                .error(function() {
                    notifications.danger('Invalid server response.');
                })
            ;
        };

        $scope.isReorderingAllowed = function() {
            return $scope.selectedStatus == 'public' && $scope.searchText == '';
        };

        $scope.startReordering = function() {
            refreshProductsOrder();
            $scope.reorderingEnabled = true;
        };

        $scope.reorderProductsBy = function(field) {
            var columns = {
                'name'  : 1,
                'id'    : 13,
                'price' : 8
            };

            var index = columns[field];

            if (!index || !$scope.tableInstance.DataTable) {
                return;
            }

            $scope.tableInstance.DataTable.order([index, 'asc']).draw();
            refreshProductsOrder();
        };

        $scope.applyReordering = function() {
            $http
                .post(
                    Routing.generate('products_reorder', {
                        id: $scope.currentStore.id
                    }),
                    {
                        productsOrder: $scope.productsOrder
                    }
                )
                .success(function(response) {
                    if (!response.success) {
                        notifications.danger(data.error || 'Unknown error.');
                        return;
                    }

                    $scope.products = response.products;
                    $scope.reorderingEnabled = false;

                    notifications.success('Products reordered successfully.');
                })
                .error(function() {
                    notifications.danger('Invalid server response.');
                    $scope.cancelReordering();
                })
            ;
        };

        $scope.cancelReordering = function() {
            if (!$scope.reorderingEnabled) {
                return;
            }

            if ($scope.tableInstance.DataTable) {
                $scope.tableInstance.DataTable.order(sortingOrder).draw();
            }

            $scope.reorderingEnabled = false;
        };

        $scope.setStatus = function(status) {
            if (status == $scope.selectedStatus) {
                return;
            }

            // hack: changing activeView for a while makes datatables recompile, avoiding ES-3494 bug
            var currentView = $scope.activeView;
            $scope.activeView = '';
            vm.statusToChange = '';
            vm.allChecked = false;
            $scope.tileViewInstance.pages.current = 1;
            $scope.sorting.direction = 'asc';
            $scope.sorting.id = 'priority';
            $scope.selectedStatus = status;
            $scope.cancelReordering();
            $scope.getProducts();

            $timeout(function() {
                $scope.activeView = currentView;
            });
        };

        $scope.setSorting = function (sortingId) {
          if ($scope.sorting.id !== sortingId) {
              $scope.sorting = {id: sortingId, direction: 'asc'};
          } else {
              $scope.sorting = {id: sortingId, direction: $scope.sorting.direction === 'asc' ? 'desc' : 'asc'};
          }
          $scope.getProducts();
        };

        $scope.init = function() {
            $scope.getProducts();
            $scope.checkReportsStatus();
        };

        $scope.getProducts = function() {
            $scope.loading = true;
            $http.get(Routing.generate('products_get', {
                id: $scope.currentStore.id,
                status: $scope.selectedStatus || 'all'
            }), {params: {
                    limit: $scope.data.displayLength,
                    page: $scope.tileViewInstance.pages.current,
                    query: $scope.tileViewInstance.search,
                    sorting: $scope.sorting.id,
                    direction: $scope.sorting.direction,
                }})
                .success(function(data) {
                    if (!data.hasOwnProperty('products')) {
                        notifications.danger(data.message);
                        return;
                    }

                    $scope.products = data.products;
                    $scope.count = data.count;
                    vm.allChecked = false;
                    $scope.freshProductsCountPerStatus = data.freshProductsCountPerStatus;

                    $timeout(function() {
                        angular.element(document.getElementById('filterText')).triggerHandler('keyup');
                    }, 150);
                })
                .finally(function() {
                    $timeout(function() {
                        $scope.$emit('datatable.updated');
                        $scope.loading = false;
                        calcTileViewPages($scope.count);
                    });
                })
            ;
        };

        $scope.getFreshProductsCount = function(status) {
            return $scope.freshProductsCountPerStatus[status];
        };

        $scope.getProductUrl = function(product) {
            return $scope.productUrlTemplate.replace('_slug_', product.slug);
        };

        $scope.cloneProduct = function(product, index) {
            $http.post(Routing.generate('products_clone', {
                    id: $scope.currentStore.id,
                    productId: product.id
                }))
                .success(function(response) {
                    if (!response.success) {
                        notifications.danger(response.message);
                        return;
                    }

                    if ($scope.selectedStatus === 'drafts') {
                        $scope.getProducts();
                    } else {
                        $scope.setStatus('drafts');
                    }

                    notifications.success('Product cloned successfully.');
                })
                .error(function() {
                    notifications.danger('Invalid server response.');
                })
            ;
        };

        $scope.checkoutLink = function(product) {
            $uibModal.open({
                templateUrl: 'productCheckoutLink.html',
                controller: 'ProductCheckoutLinkCtrl',
                windowClass: 'modal-primary',
                controllerAs: 'vm',
                resolve: {
                    product: () => product,
                    store: () => $scope.currentStore,
                }
            });
        };

        $scope.lockProduct = function(product) {
            if (product.isUpdating) {
                return;
            }

            product.isUpdating = true;

            $http.put(
                    Routing.generate('products_lock', { store: $scope.currentStore.id, product: product.id }),
                    { private : !product.private }
                )
                .then(function (response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    product.private = !product.private;
                    notifications.success('Product has been marked as ' + (product.private ? 'private' : 'public' ));

                }, function (response) {
                    notifications.danger('Request error.');
                })
                .finally(function () {
                    product.isUpdating = false;
                });

        };

        $scope.featureProduct = function (product) {
            if (product.isFeaturedUpdating) {
                return;
            }

            product.isFeaturedUpdating = true;

            $http.put(
                Routing.generate('products_feature', { store: $scope.currentStore.id, product: product.id }),
                { featured : !product.featured }
            )
                .then(function (response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    product.featured = !product.featured;
                    notifications.success('Product has been marked as ' + (product.featured ? 'featured' : 'standard' ));

                }, function (response) {
                    notifications.danger('Request error.');
                })
                .finally(function () {
                    product.isFeaturedUpdating = false;
                });
        };

        $scope.deleteProduct = function(product) {
            ProductUtils
                .delete($scope.currentStore, product)
                .then(() => {
                    $scope.getProducts()
                });
        };

        $scope.searchTable = function(search) {
            $scope.tileViewInstance.search = search;
            $scope.tileViewInstance.pages.current = 1;
            $scope.getProducts()
        };

        $scope.creatingProduct = false;

        $scope.createProduct = function (fields) {
            if ($scope.creatingProduct) {
                return;
            }

            $scope.creatingProduct = true;

            $http
                .post(
                    Routing.generate('products_create', { id: $scope.currentStore.id }),
                    fields
                )
                .then(function (response) {
                    if (response.data.success) {
                        $window.location.href = Routing.generate('products_process', {
                            store: $scope.currentStore.id,
                            product: response.data.product.id
                        });
                    } else {
                        $scope.creatingProduct = false;
                        notifications.danger(response.data.message ? response.data.message : 'Request error.');
                    }
                }, function (response) {
                    $scope.creatingProduct = false;
                    notifications.danger((response.data !== null && response.data.hasOwnProperty('message')) ? response.data.message : 'Request error.');
                });
        };

        $scope.createService = function (fields) {
            if ($scope.creatingProduct) {
                return;
            }

            $scope.creatingProduct = true;

            $http
                .post(
                    Routing.generate('products_create_service', { id: $scope.currentStore.id }),
                    fields
                )
                .then(function (response) {
                    if (response.data.success) {
                        $window.location.href = Routing.generate('products_process', {
                            store: $scope.currentStore.id,
                            product: response.data.product.id
                        });
                    } else {
                        $scope.creatingProduct = false;
                        notifications.danger(response.data.message ? response.data.message : 'Request error.');
                    }
                }, function (response) {
                    $scope.creatingProduct = false;
                    notifications.danger((response.data !== null && response.data.hasOwnProperty('message')) ? response.data.message : 'Request error.');
                });
        };

        $scope.createFromSource = function() {
            $scope.selectingProductSource = false;

            var modal = wizardModal.open({
                'templateUrl': 'addFromSourceModal.html',
                'size': 'md',
                'controller': 'ProductSourceModalController',
                'resolve': {
                    'storeId': function () {
                        return $scope.currentStore.id;
                    }
                }
            });

            modal.result.then($scope.createProduct);
        };

        $scope.importFromFile = function () {
            var modal = wizardModal.open({
                'templateUrl': 'importFromCsv.html',
                'size': 'lg',
                'controller': 'ProductImportCsvModalController as vm',
                'resolve': {
                    'storeId': function () {
                        return $scope.currentStore.id;
                    }
                }
            });

            modal.result.then(function () {
                $scope.openSuccessImportModal();
                $scope.setStatus('drafts');
                $scope.checkReportsStatus();
            });
        }

        $scope.openSuccessImportModal = function () {
            wizardModal.open({
                'templateUrl': 'successImportModal.html',
                'size': 'md',
                'controller': function ($scope, $uibModalInstance) {
                    $scope.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            });
        };

        $scope.checkReportsStatus = function () {
            $http.get(Routing.generate('api_check_import', {store: $scope.currentStore.id})).then(function (response) {
                $scope.showWaitingReports = response.data.waiting;
                $scope.showFinishedReports = response.data.finished;
                $scope.finishedReportData = {
                    success: response.data.success,
                    error: response.data.errors,
                    reportId: response.data.id
                }
            })
        }

        $scope.showReportsStatus = function () {
            if ($scope.showFinishedReports) {
                var modal = wizardModal.open({
                    'templateUrl': 'importReportModal.html',
                    'size': 'lg',
                    'resolve': {
                        'storeId': function () {
                            return $scope.currentStore.id;
                        },
                        'report': function () {
                            return $scope.finishedReportData;
                        },
                    },
                    'controller': function ($scope, $uibModalInstance, storeId, report) {
                        $scope.selectedStatus = 'success';
                        $scope.products = report.success;

                        $scope.getProductsCount = function (name) {
                            return report[name].length;
                        }
                        $scope.setStatus = function (name) {
                            $scope.selectedStatus = name;
                            $scope.products = report[name];
                        }
                        $scope.close = function () {
                            $uibModalInstance.close();
                        };

                        $scope.getExportLink = function () {
                            return Routing.generate('products_generate_error_report', {task: report.reportId});
                        }
                    }
                });

                modal.result.then(function () {
                    $http.post(Routing.generate(
                        'api_confirm_view',
                        {store: $scope.currentStore.id, id: $scope.finishedReportData.reportId}
                    )).then(function (response) {
                        $scope.checkReportsStatus();
                    })
                });
            } else  {
                $scope.checkReportsStatus()
            }
        }

        $scope.switchView = function (view) {
            $scope.activeView = view;
            StorageBag.put('es-ui-product-view', view);
        };

        $scope.getPrimaryImageUrl = function (product) {
            return $filter('mediaSrc')(product);
        };

        $scope.nextPage = function () {
            var pages = $scope.tileViewInstance.pages;
            $scope.tileViewInstance.pages.current = (pages.current === pages.max) ? pages.max : pages.current + 1;
            $scope.getProducts();
        };

        $scope.prevPage = function () {
            var pages = $scope.tileViewInstance.pages;
            $scope.tileViewInstance.pages.current = (pages.current === 1) ? 1 : pages.current - 1;
            $scope.getProducts();
        };

        $scope.setCurrentPage = function (page) {
            $scope.tileViewInstance.pages.current = page;
            $scope.getProducts();
        };

        $scope.getTileViewProducts = function (products) {
            var newSet = {}, i = 0;

            _.forEach(products, function (product) {
                // Apply search filter
                if ($scope.tileViewInstance.search.length > 0 &&
                    product.name.search(new RegExp('(' + $scope.tileViewInstance.search + ')', 'gi')) === -1 &&
                    product.title.search(new RegExp('(' + $scope.tileViewInstance.search + ')', 'gi')) === -1
                ) {
                    return true;
                }

                // Increase counter
                i++;

                newSet[product.id] = product;
            });

            var sortable = [];
            for (var product in newSet) {
                sortable.push([product, newSet[product]]);
            }

            if ($scope.sorting.id == 'priority') {
                sortable.sort(function (a, b) {
                    return a[1].defaultPriority - b[1].defaultPriority;
                });
            }

            if ($scope.sorting.id == 'name') {
                sortable.sort(function (a, b) {
                    return a[1].name < b[1].name ? -1 : 1;
                });
            }

            if ($scope.sorting.id == 'price') {
                sortable.sort(function (a, b) {
                    var aPrice = parseFloat(a[1].currentPrice ? a[1].currentPrice : a[1].regularPrice)
                    var bPrice = parseFloat(b[1].currentPrice ? b[1].currentPrice : b[1].regularPrice)
                    return aPrice - bPrice;
                });
            }
            if ($scope.sorting.id == 'salesTerms') {
                sortable.sort(function (a, b) {
                    return a[1].timer.timer_type < b[1].timer.timer_type ? -1 : 1;
                });
            }
            if ($scope.sorting.id == 'quantity') {
                sortable.sort(function (a, b) {
                    var qa = parseInt(a[1].quantity) - parseInt(a[1].bought);
                    var qb = parseInt(b[1].quantity) - parseInt(b[1].bought);
                    return qa - qb;
                });
            }

            if ($scope.sorting.id == 'modified') {
                sortable.sort(function (a, b) {
                    var dateA = new Date(a[1].updatedAtDateTime), dateB = new Date(b[1].updatedAtDateTime);
                    return dateA < dateB ? -1 : 1;
                });
            }

            var sorted = [];
            sortable.forEach(function(item){
                sorted.push(item[1])
            })

            return $scope.sorting.direction == 'asc' ? sorted : sorted.reverse();
        };

        var getRowNumber = function(productId) {
            var number = -1;

            angular.forEach(getTableRows(), function(row, index) {
                if ($(row).attr('product-id') == productId) {
                    number = index;
                }
            });

            return number;
        };

        var refreshProductsOrder = function() {
            $scope.productsOrder = [];

            angular.forEach(getTableRows(), function(row, index) {
                $scope.productsOrder.push(parseInt($(row).attr('product-id')));
            });
        };

        var getTableRows = function() {
            return $('#products-table > tbody > tr');
        };
    }])
;
